import React from 'react'

import Mainpage from './mainpage';
import Secondpage from './secondpage';
import Thirdpage from './thirdpage';
import Fourthpage from './fourthpage';
import Fifthpage from './fifthpage';
import Sixthpage from './sixthpage';

const landingpage = () => {
    return (
        <>
            <Mainpage />
            <Secondpage />
            <Thirdpage />
            <Fourthpage />
            <Fifthpage />
            <Sixthpage/>
        </>
    )
}

export default landingpage
